
import ProgressCircular from "@/components/base/ProgressCircular"

import vueVimeoPlayer from "vue-vimeo-player"
import Vue from "vue"
Vue.use(vueVimeoPlayer)

export default {
    name: "VimeoExpansionPanel",
    components: { ProgressCircular },
    props: {
        videoUrl: {
            type: String,
            required: true,
        },
        videoId: {
            type: String,
            required: true,
        },
        headline: {
            type: String,
            default: "Beispiel ansehen ›",
        },
    },
    data: () => ({
        isLoaded: false,
    }),
}
